import Surface from "@/components/_shared/controls/Surface";
import { useAuthentication } from "@/hooks/framework/useAuthentication";
import { Box, MenuItem, Select, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import EventsTable from "../../components/rangers/tables/EventsTable";

const tabOptions = [
  "All",
  "My Upcoming Events",
  "My Past Events",
  "My Organised Events",
  "Bookmarked Events"
];
export default function SearchEvents() {
  const auth = useAuthentication();

  const [tabIndex, setTabIndex] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Surface sx={{ p: 2 }}>
      <Box sx={{ display: { xs: "none", sm: "flex" }, mb: 1, borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabIndex} onChange={handleChange}>
          {tabOptions.map((option, index) => (
            <Tab key={index} label={option} />
          ))}
        </Tabs>
      </Box>
      <Select
        onChange={(event) => setTabIndex(event.target.value)}
        value={tabIndex}
        defaultValue={0}
        sx={{ display: { xs: "flex", sm: "none" }, mb: 1 }}
      >
        {tabOptions.map((option, index) => (
          <MenuItem key={index} value={index}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {tabIndex === 0 && <EventsTable showHostEvent />}
      {tabIndex === 1 && <EventsTable showFilter={false} showHostEvent showIfParticipant />}
      {tabIndex === 2 && <EventsTable dateDescending showCompleted showIfHostOrParticipant />}
      {tabIndex === 3 && <EventsTable dateDescending userId={auth.userId} />}
      {tabIndex === 4 && <EventsTable dateDescending showIfBookmarked />}
    </Surface>
  );
}
